import React, { useState, useEffect } from 'react';
import axios from 'axios';
import SocialMediaFeed from '../SocialMediaFeed';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const SocialFeedSection = () => {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        // Use public settings endpoint (no auth required)
        const res = await axios.get(`${API_URL}/api/settings`);
        setSettings(res.data || {});
      } catch (error) {
        console.log('Settings not available');
      } finally {
        setLoading(false);
      }
    };
    fetchSettings();
  }, []);

  if (loading) return null;
  
  // Don't render if social feed is disabled
  if (!settings?.social_feed_enabled) return null;

  // Don't render if no social accounts configured
  const hasSocial = settings.social_instagram || settings.social_twitter || settings.social_facebook;
  if (!hasSocial) return null;

  return (
    <section className="py-20 bg-white" data-testid="social-feed-section">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-[#0a0203] mb-4">
            Join Our Community
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Follow us for freeze drying tips, recipes, and inspiration from our amazing community
          </p>
        </div>
        
        <SocialMediaFeed 
          instagramUsername={settings.social_instagram}
          twitterUsername={settings.social_twitter}
          facebookPageId={settings.social_facebook}
          showTitle={false}
          maxPosts={6}
        />
      </div>
    </section>
  );
};

export default SocialFeedSection;
